export default __webpack_public_path__ + "static/media/FiguradoClosed.ee2d3518.jpg";